import { render, staticRenderFns } from "./manage-name.vue?vue&type=template&id=0ed32af2&scoped=true"
import script from "./manage-name.vue?vue&type=script&lang=ts"
export * from "./manage-name.vue?vue&type=script&lang=ts"
import style0 from "./manage-name.vue?vue&type=style&index=0&id=0ed32af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed32af2",
  null
  
)

export default component.exports